import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';

export interface MessageEvent {
  type: 'primary' | 'success' | 'warning' | 'danger';
  data: Message;
}

export interface Message {
  message: string;
  status?: number;
}

export interface ConfirmButton {
  text: string;
  role?: string;
  cssClass?: string | string[];
  handler?: (value: any) => boolean | void | { [key: string]: any };
}

export interface Confirm {
  header?: string;
  message: string;
  buttons: (ConfirmButton | string)[];
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  public readonly onConfirm: EventEmitter<Confirm>;

  public readonly onMessage: EventEmitter<MessageEvent>;

  public readonly onError: EventEmitter<HttpErrorResponse>;

  constructor() {
    this.onConfirm = new EventEmitter<Confirm>();
    this.onMessage = new EventEmitter<MessageEvent>();
    this.onError = new EventEmitter<HttpErrorResponse>();
  }

  public addMsgInfo(data: Message): void {
    this.onMessage.emit({ type: 'primary', data });
  }

  public addMsgWarning(data: Message): void {
    this.onMessage.emit({ type: 'warning', data });
  }

  public addMsgSuccess(data: Message): void {
    this.onMessage.emit({ type: 'success', data });
  }

  public addMsgDanger(data: Message): void {
    this.onMessage.emit({ type: 'danger', data });
  }

  public addError(error?: HttpErrorResponse): void {
    this.onError.emit(error);
  }

  public addConfirm(confirm: Confirm): void {
    this.onConfirm.emit(confirm);
  }
}
